<template>
    <div class="land-promo">
        <div class="land-page-carousel">
            <swiper :options="swiperOption" ref="LandPromoCarousel">
                <swiper-slide v-for="(slide, index) in salesCard.project_land_site.land_gallery" :key="index">
                    <div class="promo-pic" :style="'background-image: url(' + slide + ')'"></div>
                </swiper-slide>
            </swiper>
            <div class="promo-carousel-in">
                <div class="container">
                    <div class="promo-header">
                        <div class="promo-logo">
                            <img :src="saleItem.logo_color">
                        </div>
                    </div>
                    <!-- <div class="promo-title">
                        <h2 v-html="salesCard.project_title"></h2>
                    </div> -->
                    <div class="promo-land-btns" v-if="salesCardPage != null && salesCardPage.land_site_btns != null && salesCard != null">
                        <div class="flats" v-if="salesCard != null && salesCard.project_land_site.flats_init == 'true' && project != 'yassytower'">
                            <!-- <a href="#"  v-if="objectDataCRM != null && projectNameG != 'aqualina' && projectNameG == 'alfarabi27'" v-scroll-to="{
                                el: '#land-flats',
                                offset: -100
                            }">
                                СМОТРЕТЬ
                                <span class="count">{{objectDataCRM.apartmentsQuantity}}</span> 
                                <span class="word">{{correctFlatWord(objectDataCRM.apartmentsQuantity)}}</span>
                            </a> -->
                            <!-- v-if="projectNameG == 'aqualina'" -->
                            <!-- v-if="projectNameG != 'alfarabi27'" -->
                            <a href="#" v-if="salesCard.project_stie_flats_filter_init == 'true'"
                                v-scroll-to="{
                                    el: '#land-flats',
                                    offset: -100
                                }">
                                <span v-if="lang != 'kz/'">Забронировать квартиру</span>
                                <span v-else>Пәтерге тапсырыс беріңіз</span>
                            </a>
                            <a href="#" v-else
                                v-scroll-to="{
                                    el: '#land-flats',
                                    offset: -100
                                }">
                                <span v-if="lang != 'kz/'">Смотреть квартиры</span>
                                <span v-else>Пәтерлерді қарау</span>
                            </a>
                        </div>
                        <div class="present" v-if="salesCard.project_land_site.land_present_file != '' && salesCard.project_land_site.land_present_file != false && salesCard.project_land_site.land_present_file != undefined">
                            <a :href="salesCard.project_land_site.land_present_file" download target="_blank">{{salesCardPage.land_site_btns.present}}</a>
                        </div>
                    </div>
                    <div class="swiper-controls sales-land-controls" v-if="salesCard.project_land_site.land_gallery != undefined && salesCard.project_land_site.land_gallery.length > 1">
                        <div class="container">
                            <div class="sales-land-btn-prev slider-btn">
                                <svg-icon icon-class="left-arrow" className="icon icon-arrow-left"/>
                            </div>
                            <div class="sales-land-btn-next slider-btn">
                                <svg-icon icon-class="right-arrow" className="icon icon-arrow-right"/>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-pagination sales-land-pagination" v-if="salesCard.project_land_site.land_gallery != undefined && salesCard.project_land_site.land_gallery.length > 1"></div>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    // import PROMOpage from '@/components/sales/sales-promo-page.vue'
    export default {
        name: 'sale-land-promo',
        props: ['cityProject'],
        components: {
        },
        data () {
            return {
                project: window.host,
                projectNameG: window.host,
                lang: window.GlobalLang,
                swiperOption: {
                    speed: 800,
                    loop: true,
                    observer: true,
                    observeParents: true,
                    effect: 'fade',
                    slidesPerView: 1,
                    simulateTouch: false,
                    watchSlidesVisibility: true,
                    lazy: {
                        loadPrevNext: true,
                        loadOnTransitionStart: true
                    },
                    autoplay: {
                        delay: 3500,
                        disableOnInteraction: true,
                    },
                    navigation: {
                        nextEl: '.sales-land-btn-next',
                        prevEl: '.sales-land-btn-prev',
                    },
                    pagination: {
                        el: '.sales-land-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                },
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
            saleItem: 'loadSaleCardItem',
            objectDataCRM: 'loadObjectDataCrm',
        }),
        methods: {
            correctFlatWord(number) {
                var result;
                var word = 'квартир'
                // console.log(filter, id)
                result = parseFloat(number);
                var final = result % 10
                // console.log(result);
                if (result != '10' && result != '11' && result != '12' && result != '13' && result != '14') {
                     if (final == 2 || final == 3 || final == 4) {
                        word = 'квартиры'
                    } else if (final == 1) {
                        word = 'квартира'
                    }
                }
                return word;
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            if (this.projectNameG != 'aqualina') {
                this.$store.dispatch('getObjectFromCRM', {
                    "complexCodes": [this.salesCard.crm_code]
                }).then((response) => {
                //    console.log('response complete');
                });
            } 
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-promo.scss';
    @import '@/styles/respond/sales/sales-land-partials/land-promo-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>